import { useThemeContext } from '@huggg/react-components';
import { GuidedChoiceQuestion } from 'components/GuidedChoice/GuidedChoiceQuestion';
import { GuidedChoiceResult } from 'components/GuidedChoice/GuidedChoiceResult';
import { PageTitle } from 'components/misc';
import { withHuggg } from 'hoc';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  proceedToTargetId,
  goBack,
  getCurrentScreen,
  setConfig,
} from 'redux/modules/guidedChoice';
import { getSegments } from 'redux/modules/huggg';

export const GuidedChoiceFlowUnconnected = (props) => {
  const {
    segments,
    guidedChoiceConfig,
    currentScreen,
    proceedToTargetId,
    goBack,
    setConfig,
    onSelectSegment,
  } = props;

  useEffect(() => {
    if (Boolean(guidedChoiceConfig)) {
      setConfig(guidedChoiceConfig);
    }
  }, [guidedChoiceConfig, setConfig]);

  const { name: theme } = useThemeContext();

  return (
    <div style={{ backgroundColor: theme === 'welfare' ? '#EEF0F8' : '#FFF' }}>
      <PageTitle title={'Choose Your Product'} />
      {currentScreen && currentScreen.type === 'question' && (
        <GuidedChoiceQuestion
          {...currentScreen}
          onOptionClick={proceedToTargetId}
          onBackClick={goBack}
        />
      )}
      {currentScreen && currentScreen.type === 'result' && (
        <GuidedChoiceResult
          {...currentScreen}
          segments={segments}
          onBackClick={goBack}
          onCtaClick={onSelectSegment}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentScreen: getCurrentScreen(state),
    segments: getSegments(state),
  };
};

export default compose(
  withHuggg,
  connect(mapStateToProps, { proceedToTargetId, goBack, setConfig }),
)(GuidedChoiceFlowUnconnected);
